import { render, staticRenderFns } from "./Arbeitsplatz.vue?vue&type=template&id=58b77ab0"
import script from "./Arbeitsplatz.vue?vue&type=script&lang=js"
export * from "./Arbeitsplatz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports